import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { verbalTheme } from "../themes/verbal.theme";

export const drawerWidth = 260;

const styles = createStyles({
    main: {
        flex: 1,
        background: verbalTheme.palette.background.default,
    },
    infoSection: {
        [verbalTheme.breakpoints.down("lg")]: {
            display: "none",
        },
    },
});

export const useLoginLayoutStyle = makeStyles(styles);
